module.exports = __webpack_public_path__ + "img/Roza.a495b8a9.jpg";